import { ref, watch } from 'vue'
import { useDisplay } from 'vuetify'

/**
 * useIsMobile - small helper to derive a boolean from Vuetify's display width.
 * Defaults to a 700px breakpoint to match existing behavior.
 */
export function useIsMobile(threshold = 700) {
  const { width } = useDisplay()
  const isMobile = ref<boolean>(width.value < threshold)

  watch(
    () => width.value,
    () => {
      isMobile.value = width.value < threshold
    }
  )

  return { isMobile }
}
